<template class="link-export-modal">
	<link-dialog
		:loading="loading"
		v-model="show"
		dialogClass="link-export-modal-dialog"
		vertical="center"
		@confirm="p_confirm"
		@cancel="show = false"
		:noPadding="true"
		:noHeader="true"
		width="480px">
		<div class="link-dialog-head" style="padding: 16px; margin-bottom: 16px;">
			<div class="link-dialog-title">
				<span>{{$t('LinkAutoTable.exportOption')}}</span>
			</div>
			<div class="link-dialog-head-operator">
				<link-icon icon="link-icon-close" @click="hide" class="link-dialog-close-icon"/>
			</div>
		</div>
		<link-table :data="tableData" :rowHeight="28">
			<link-table-column-check size="small" activeColor="#1F74FF" inactiveColor="#e5e6e9" :single-select="false" ref="multipleTable" @rows-mounted="mon" autoSort/>
			<link-table-column :title="$t('LinkAutoTable.selectAll')" field="name" :sort="false" :fit="1" :width="100"/>
		</link-table>
		<div>
			<el-row class="link-dialog-foot">
				<el-col :span="4">
					<span>{{$t('LinkAutoTable.exportOption')}}：</span>
					<!--<el-input class="inputCode" v-model="input" size="mini" placeholder="请输入文件名称..."></el-input>-->
				</el-col>
				<el-col :span="6">
					<link-lov-select lovType="EXPORT_TYPE" v-model="value" hideClearIcon :width="72" :selectHeight="null"/>
				</el-col>
				<el-col :span="14" style="text-align: right;">
					<link-button @click="show = false" type="line" style="width: 72px; height: 28px; margin-right: 8px;">{{$t('global.cancel')}}</link-button>
					<link-button @click="p_confirm('current')" style="width: 84px; height: 28px; margin-right: 8px;">{{$t('LinkAutoTable.exportCurrentPage')}}</link-button>
					<link-button @click="p_confirm('all')" style="width: 72px; height: 28px;">{{$t('LinkAutoTable.exportAll')}}</link-button>
				</el-col>
			</el-row>
		</div>
	</link-dialog>
</template>

<script>
	import LinkTableColumnCheck from '../table-expansion/check/link-table-column-check';

	/**
	 * 以企业信息设置中的默认文件导出类型为准
	 * @author  韦胜健
	 * @date    2020/12/23 14:40
	 */
	const getDefaultExportType = (() => {
		let enterprise;// 企业信息
		return async (context) => {
			if (!enterprise) {
				context.loading = true
				const user = await context.$http.getUser()
				try {
					const resp = await context.$http.post('/link/enterprise/queryByExamplePage', {code: user.corpId, pageFlag: false, totalFlag: false,}, true)
					enterprise = !!resp.rows && !!resp.rows[0] ? resp.rows[0] : resp.result
				} catch (e) {
					context.$nav.error('获取企业信息失败！' + e.toString())
				}
				context.loading = false
			}
			return !!enterprise ? enterprise.exportType : null
		}
	})();

	export default {
		name: 'link-export-modal',
		components: {LinkTableColumnCheck},
		props: {
			defaultExportType: {type: String},
		},
		data: function () {
			return {
				loading: false,
				data: [],
				typeList: [
					{name: 'csv', val: 'csv'},
					/* {name: '.xls', val: 'xls',},*/
					{name: 'excel', val: 'xlsx'}
				],
				onConfirm: null,
				input: '',                                  // 导出文件名称输入框存值
				value: this.defaultExportType,              // 导出文件类型选择框存值
				tableData: this.data,                       // 列表内容原始存值
				show: false                                	// 弹出框的显示
			};
		},
		watch: {
			// 监听外部data的变化，从而改变内部tableData的变化。
			data: {
				handler: function (val) {
					if (this.tableData !== val) {
						this.tableData = val;
					}
				},
				deep: true
			}
		},

		methods: {
			/**
			 * desc 关闭弹框
			 * @author 刘志龙
			 * @date 2019/3/28 14:34
			 * @params
			 */
			hide() {
				this.show = false;
			},
			/**
			 * desc
			 * @author huyang
			 * @date 2019-02-25 14:59
			 * @params
			 */
			p_confirm(val) {
				var arr = this.$refs.multipleTable.getSelectedRows();
				var isForm = true;
				if (arr.length == 0) {
					isForm = false;
					this.$message.warning(LinkVue.$t('LinkAutoTable.selectExportOption'));
				} else if (this.value == '') {
					isForm = false;
					this.$message.warning(LinkVue.$t('LinkAutoTable.selectExportFileType'));
				}
				for (var j = 0; j < arr.length; j++) {
					delete arr[j].checked;
				}
				if (isForm) {
					var obj = {
						fileName: this.input,
						fileType: this.value,
						fields: arr,
						range: val
					};
					// this.$refs.multipleTable.clearSelection();
					this.input = '';

					Boolean(this.onConfirm) && this.onConfirm(obj);
				}
				this.show = false;
			},

			/**
			 * desc 交换数组元素
			 * @author huyang
			 * @date 2019/1/28 19:51
			 * @params arr：对应的数组
			 * @params index1：当前列表行的索引值
			 * @params index2：目标列表行的索引值
			 */
			swapItems(arr, index1, index2) {
				arr[index1] = arr.splice(index2, 1, arr[index1])[0];
				return arr;
			},

			/**
			 * desc 列表顺序上移
			 * @author huyang
			 * @date 2019/1/28 19:51
			 * @params index: 当前数据的下标值
			 */
			setUp(index) {
				if (index == 0) return;
				this.tableData = this.swapItems(this.tableData, index, index - 1);
			},

			/**
			 * desc 列表顺序下移
			 * @author huyang
			 * @date 2019/1/28 19:51
			 * @params index: 当前数据的下标值
			 */
			setDown(index) {
				if (index == this.tableData.length - 1) return;
				this.tableData = this.swapItems(this.tableData, index, index + 1);
			},

			/**
			 * desc 列表顺序置顶
			 * @author huyang
			 * @date 2019/1/28 19:51
			 * @params index: 当前数据的下标值
			 */
			setTop(index) {
				for (var i = index; i >= 0; i--) {
					this.setUp(i);
				}
			},

			/**
			 * desc 点击单个项，列表多选时，为每个选中的项上添加checked标识
			 * @author huyang
			 * @date 2019/1/28 19:53
			 * @params list: 返回当前被选中的列表数组
			 * @params val: 多选的数据list
			 */
			selectChange(list, val) {
				val.checked = val.checked !== true;
			},

			/**
			 * desc 监控dialog打开之前调用的方法，设置默认全选
			 * @author huyang
			 * @date 2019-03-11 11:53
			 * @params
			 */
			mon() {
				this.$nextTick(() => {
					this.$refs.multipleTable.selectAll();
				});
			},

			/**
			 * desc 点击全选或全不选时，为每个选中的项上添加或删除checked标识
			 * @author huyang
			 * @date 2019/1/28 19:56
			 * @params list: 返回当前被选中的列表数组
			 */
			selectAllChange(list) {
				if (list.length === 0) {
					for (let i = 0; i < this.tableData.length; i++) {
						if (this.tableData[i].checked !== undefined) {
							delete this.tableData[i].checked;
						}
					}
				} else {
					for (let i = 0; i < this.tableData.length; i++) {
						this.tableData[i].checked = true;
					}
				}
			},

			/**
			 * 初始化 默认 导出文件类型
			 * @author  韦胜健
			 * @date    2020/12/23 10:25
			 */
			async initExportType() {
				this.value = this.defaultExportType || await getDefaultExportType(this) || 'xlsx'
			},
		},
		mounted() {
			this.initExportType()
		}
	};
</script>

<style lang="scss">

	@include themeify {
		.link-export-modal-dialog {
			.link-button.link-button-none.link-button-color-primary {
				color: $color-primary;
			}

			.operate-button {
				width: 140px !important;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.link-button {
					padding: 0;
					width: 44px;
					min-width: initial;
				}

				.icon-upright {
					color: #1F74FF;
				}
			}

			.link-dialog-body {
				padding-bottom: 0 !important;
			}

			.link-dialog-foot {
				font-size: 12px;
			}

			.lv-table-head tr:not(.lv-table-column-space) {
				font-size: 12px;
				font-weight: 400;
			}

			.lv-table-row td {
				border: none;
			}

			.lv-table-body tr:not(.lv-table-column):not(:last-child) .lv-table-cell {
				border-bottom: none;
				border-top: none;
			}

			.lv-base-table {
				font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif !important;
				border: none;
				margin-left: 80px;
				width: 400px;
			}

			.lv-table-head {
				border-bottom: none;
			}

			.lv-table-cell {
				background-color: #FFFFFF;
			}

			.link-dialog-foot {
				padding: 16px;
			}

			.lv-table-head-item {
				background-color: #FFFFFF;
			}

			.lv-table-cell {
				padding-left: 5px;
			}
		}
	}
</style>
